import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerQueryKeys } from "./keys";
import { CreateCustomerFormFields } from "../../models/Customer/CreateCustomer";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { UpdateCustomerFormFields } from "../../models/Customer/UpdateCustomer";

export default function useCustomerMutations() {
  const queryClient = useQueryClient();
  const { saveHandlers } = useDefaultCRUDHandlers("Customer");
  const { post, put, del } = useApiHelper();

  const create = useMutation({
    mutationFn: (customer: CreateCustomerFormFields) => post(`/customer`, customer),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CustomerQueryKeys.all() });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  const update = useMutation({
    mutationFn: (updatedCustomer: UpdateCustomerFormFields) =>
      put(`/customer/${updatedCustomer.id}`, updatedCustomer),
    onSuccess: (_, updateInput) => {
      queryClient.invalidateQueries({ queryKey: CustomerQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: CustomerQueryKeys.single(updateInput.id) });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  const remove = useMutation({
    mutationFn: (customerId: string) => del(`/customer/${customerId}`),
    onSuccess: (_, deleteInput) => {
      queryClient.invalidateQueries({ queryKey: CustomerQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: CustomerQueryKeys.single(deleteInput) });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  return {
    create,
    update,
    remove,
  };
}
